

const CHECK_COUPON = 'coupons/CHECK_COUPON';
const CLEAR_COUPON = 'coupons/CLEAR_COUPON';

const checkCoupon = (coupon) => ({
  type: CHECK_COUPON,
  coupon
});

export const clearCoupon = () => ({
  type: CLEAR_COUPON
});

export const checkCouponThunk = (code, phone) => async (dispatch) => {
  try {
    const response = await fetch(`https://hutaoadmin.onrender.com/api/coupons/validate-hongkong`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        couponId: code,
        phone: phone,
      }),
    });

    const data = await response.json();

    if (response.ok) {
      dispatch(checkCoupon(data));
    } else {
      throw new Error(data.message || 'Invalid coupon');
    }
  } catch (error) {
    console.error('Error validating coupon:', error);
    throw error; // Rethrow for UI to handle
  }
};


const initialState = {
  coupon: {}
};

const couponReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHECK_COUPON:
      return {
        ...state,
        coupon: action.coupon
      };
    case CLEAR_COUPON:
      return {
        ...state,
        coupon: {}
      };
    default:
      return state;
  }
};

export default couponReducer;
